module.exports = __webpack_public_path__ + "img/image-about.9ea3d67e.png";